import { useMemo } from 'react';
import { useComment, useGlobal } from '@/store';
import { CommentsTable } from './components/comments-table';
import { FiltersSection } from './components/filters-section';

export const CommentsPage = () => {
  const questionIds = useComment.use.questionIds();
  const search = useComment.use.search();
  // const createdAt = useComment.use.createdAt();
  const review = useComment.use.review();
  const productId = useComment.use.productId();
  const dbType = useGlobal.use.dbType();
  const range = useComment.use.range();

  // Create filter key to trigger reload when filters change
  const filterKey = useMemo(
    () => JSON.stringify({ questionIds, search, range, review, productId, dbType }),
    [questionIds, search, range, review, productId, dbType],
  );

  return (
    <div className='flex flex-col h-full gap-4'>
      <FiltersSection />
      <CommentsTable
        filterKey={filterKey}
        productId={productId}
        questionIds={questionIds}
        search={search}
        range={range}
        review={review}
      />
    </div>
  );
};
